import { nanoid } from 'nanoid';

import { AvailabilityStatus, WorkCalendarRecord } from '../types';
import { AvailabilityDate } from './AvailabilityDate';
import { TimeSlot } from './TimeSlot';

export type AvailabilityPeriod = {
    id: string;
    startDate: string; // ISO string
    endDate: string; // ISO string
    status: AvailabilityStatus;
    timeSlots: TimeSlot[];
    dates: WorkCalendarRecord[];
};

export function createAvailabilityPeriod(initialDate: WorkCalendarRecord): AvailabilityPeriod {
    return {
        id: nanoid(),
        startDate: initialDate.date,
        endDate: initialDate.date,
        status: initialDate.status,
        timeSlots: initialDate.timeSlots || [],
        dates: [ initialDate ]
    };
}

export function addDateToPeriod(period: AvailabilityPeriod, date: WorkCalendarRecord): AvailabilityPeriod {
    if (date.date < period.endDate) {
        throw new Error('Cannot add a date before the current end date');
    }

    return {
        ...period,
        dates: [ ...period.dates, date ],
        endDate: date.date
    };
}
